// @flow @jsx h

import { h } from 'preact'
import style from './index.css'

type Props = {
  type: 'quote',
  className?: string,
  value: {
    text: string,
    cite?: string
  }
}

function Quote (props: Props) {
  const { value } = props
  const className = `${style.quote}${
    props.className ? ` ${props.className}` : ''
  }`

  return (
    <blockquote className={className}>
      <div className={style.quote__content}>
        <p dangerouslySetInnerHTML={{ __html: value.text }} />
      </div>
      {value.cite && (
        <footer className={style.quote__footer}>
          <cite>
            <svg viewBox='0 0 20 30'>
              <path d='M 5.5,5.5 L5.5,24.5 L14.5,24.5' />
              <circle cx='5.5' cy='5.5' r='3.5' />
            </svg>
            <span
              dangerouslySetInnerHTML={{
                __html: `<span class="nrk-sr">–</span> ${value.cite || ''}`
              }}
            />
          </cite>
        </footer>
      )}
    </blockquote>
  )
}

export default Quote



// WEBPACK FOOTER //
// ./src/lib/@nrk/dh-feature-components/Quote/index.js